export const API_BASE_URL = process.env.GATSBY_ENV === 'dev' ? 'http://localhost:8088' : '';
